import { computed, observable, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { OfferCounter, OfferCounterItem, Pagination, scrollToElement, Spinner, Text } from 'telia-front-react';
import { Movie } from '../stores/movierental/MovieRentalCatalogStore';
import { TranslationsContext } from '@teliaee/telia-translate';
import MovieRentalCard from './MovieRentalCard';
import TvModal from './TvModal';

interface TvRentalCatalogProps {
  rootCategoryId: string;
  movies: Movie[];
  moviesPerPage: number;
  loadMore?: (page: number) => void;
  isFetching: boolean;
  isUninitialized?: boolean;
  totalCount: number;
  onPageChange: (page: number) => void;
  isFreeOfCharge?: boolean;
  specialPricePacketIds?: number[];
}

@observer
class TvRentalCatalog extends React.Component<TvRentalCatalogProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  @observable accessor page: number = 1;
  @observable accessor observableProps: { totalCount: number; moviesPerPage: number } = {
    totalCount: this.props.totalCount,
    moviesPerPage: this.props.moviesPerPage
  };

  componentDidMount() {
    runInAction(() => {
      this.observableProps = this.props;
    });
  }

  componentDidUpdate() {
    if (this.observableProps.moviesPerPage !== this.props.moviesPerPage || this.observableProps.totalCount !== this.props.totalCount) {
      runInAction(() => {
        this.observableProps = this.props;
      });
    }
  }

  @computed
  get totalPages(): number {
    const { totalCount, moviesPerPage } = this.observableProps;
    return totalCount > 0 ? Math.ceil(totalCount / moviesPerPage) : 1;
  }

  private doPaginationChange = (page: number) => {
    runInAction(() => {
      this.props.loadMore && this.props.loadMore(page);
      this.page = page;
      this.props.onPageChange(page);
    });
    const headerOffset = document.getElementsByClassName('header__main').item(0).getClientRects().item(0).height;
    scrollToElement(document.getElementById('catalog'), undefined, headerOffset);
  };

  public render() {
    const translate = this.context.translate;
    const { movies, isFetching, isUninitialized } = this.props;
    if (isFetching && movies?.length === 0) {
      return <Spinner />;
    }
    return (
      <div id={'catalog'}>
        <Text>
          <OfferCounter>
            {movies.map((rental) => (
              <OfferCounterItem key={rental.id} className="text">
                <MovieRentalCard movie={rental} />
              </OfferCounterItem>
            ))}
          </OfferCounter>
          {movies.length === 0 && !isUninitialized && translate('movieRentalSearch.noRentalsFound')}
          <div>{this.totalPages > 1 && <Pagination pages={this.totalPages} currentPage={this.page} onChange={this.doPaginationChange} />}</div>
        </Text>
        <TvModal {...this.props} />
      </div>
    );
  }
}

export default TvRentalCatalog;
